import axios, { AxiosResponse } from 'axios';
import { ActivityResponse } from '../planning';
import { apiClient } from '../endpoints';

export interface DuplicateActivityBody {
    targetDate: string;
}

export const duplicateActivityToDate = async (activityId: string, body: DuplicateActivityBody): Promise<ActivityResponse> => {
    try {
        const response: AxiosResponse<ActivityResponse> = await apiClient.post(`/planning/activity/${activityId}/duplicate`, body);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export interface DuplicateActivitiesBody {
    activityIds: string[];
    targetDate: string;
}

export const duplicateActivitiesToDate = async (body: DuplicateActivitiesBody): Promise<ActivityResponse> => {
    try {
        const response: AxiosResponse<ActivityResponse> = await apiClient.post(`/planning/activities/duplicate`, body);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};
